/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  CreateFeaturedCategoriesDTO,
  FeaturedCategoriesListResponseDTO,
  FeaturedCategoriesMvoDTO,
  InFeaturedCategoriesDTO,
  OutFeaturedCategoriesDTO
} from "../models";
import {
  CreateFeaturedCategoriesDTOFromJSON,
  CreateFeaturedCategoriesDTOToJSON,
  FeaturedCategoriesListResponseDTOFromJSON,
  FeaturedCategoriesListResponseDTOToJSON,
  FeaturedCategoriesMvoDTOFromJSON,
  FeaturedCategoriesMvoDTOToJSON,
  InFeaturedCategoriesDTOFromJSON,
  InFeaturedCategoriesDTOToJSON,
  OutFeaturedCategoriesDTOFromJSON,
  OutFeaturedCategoriesDTOToJSON
} from "../models";

export interface DeleteFeaturedCategoryRequest {
  featuredCategoryId: number;
}

export interface GetFeaturedCategoriesRequest {
  skip: number;
  take: number;
  filterQuery?: string;
}

export interface GetFeaturedCategoryByIdRequest {
  featuredCategoryId: number;
}

export interface GetFeaturedCategoryBySlugRequest {
  platformId: number;
  slug: string;
}

export interface PatchFeaturedCategoryRequest {
  featuredCategoryId: number;
  featuredCategoriesMvoDTO: FeaturedCategoriesMvoDTO;
}

export interface PostFeaturedCategoryRequest {
  createFeaturedCategoriesDTO: CreateFeaturedCategoriesDTO;
}

export interface PutFeaturedCategoryRequest {
  featuredCategoryId: number;
  inFeaturedCategoriesDTO: InFeaturedCategoriesDTO;
}

/**
 *
 */
export class FeaturedCategoriesApi extends runtime.BaseAPI {
  /**
   */
  async deleteFeaturedCategoryRaw(
    requestParameters: DeleteFeaturedCategoryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<boolean>> {
    if (requestParameters.featuredCategoryId === null || requestParameters.featuredCategoryId === undefined) {
      throw new runtime.RequiredError(
        "featuredCategoryId",
        "Required parameter requestParameters.featuredCategoryId was null or undefined when calling deleteFeaturedCategory."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/featuredCategories/{featuredCategoryId}`.replace(
          `{${"featuredCategoryId"}}`,
          encodeURIComponent(String(requestParameters.featuredCategoryId))
        ),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<boolean>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   */
  async deleteFeaturedCategory(
    requestParameters: DeleteFeaturedCategoryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<boolean> {
    const response = await this.deleteFeaturedCategoryRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async getFeaturedCategoriesRaw(
    requestParameters: GetFeaturedCategoriesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FeaturedCategoriesListResponseDTO>> {
    if (requestParameters.skip === null || requestParameters.skip === undefined) {
      throw new runtime.RequiredError(
        "skip",
        "Required parameter requestParameters.skip was null or undefined when calling getFeaturedCategories."
      );
    }

    if (requestParameters.take === null || requestParameters.take === undefined) {
      throw new runtime.RequiredError(
        "take",
        "Required parameter requestParameters.take was null or undefined when calling getFeaturedCategories."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.skip !== undefined) {
      queryParameters["skip"] = requestParameters.skip;
    }

    if (requestParameters.take !== undefined) {
      queryParameters["take"] = requestParameters.take;
    }

    if (requestParameters.filterQuery !== undefined) {
      queryParameters["filterQuery"] = requestParameters.filterQuery;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/featuredCategories`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => FeaturedCategoriesListResponseDTOFromJSON(jsonValue));
  }

  /**
   */
  async getFeaturedCategories(
    requestParameters: GetFeaturedCategoriesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FeaturedCategoriesListResponseDTO> {
    const response = await this.getFeaturedCategoriesRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async getFeaturedCategoryByIdRaw(
    requestParameters: GetFeaturedCategoryByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OutFeaturedCategoriesDTO>> {
    if (requestParameters.featuredCategoryId === null || requestParameters.featuredCategoryId === undefined) {
      throw new runtime.RequiredError(
        "featuredCategoryId",
        "Required parameter requestParameters.featuredCategoryId was null or undefined when calling getFeaturedCategoryById."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/featuredCategories/{featuredCategoryId}`.replace(
          `{${"featuredCategoryId"}}`,
          encodeURIComponent(String(requestParameters.featuredCategoryId))
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => OutFeaturedCategoriesDTOFromJSON(jsonValue));
  }

  /**
   */
  async getFeaturedCategoryById(
    requestParameters: GetFeaturedCategoryByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OutFeaturedCategoriesDTO> {
    const response = await this.getFeaturedCategoryByIdRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async getFeaturedCategoryBySlugRaw(
    requestParameters: GetFeaturedCategoryBySlugRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OutFeaturedCategoriesDTO>> {
    if (requestParameters.platformId === null || requestParameters.platformId === undefined) {
      throw new runtime.RequiredError(
        "platformId",
        "Required parameter requestParameters.platformId was null or undefined when calling getFeaturedCategoryBySlug."
      );
    }

    if (requestParameters.slug === null || requestParameters.slug === undefined) {
      throw new runtime.RequiredError(
        "slug",
        "Required parameter requestParameters.slug was null or undefined when calling getFeaturedCategoryBySlug."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.platformId !== undefined) {
      queryParameters["platformId"] = requestParameters.platformId;
    }

    if (requestParameters.slug !== undefined) {
      queryParameters["slug"] = requestParameters.slug;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/featuredCategories/slug`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => OutFeaturedCategoriesDTOFromJSON(jsonValue));
  }

  /**
   */
  async getFeaturedCategoryBySlug(
    requestParameters: GetFeaturedCategoryBySlugRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OutFeaturedCategoriesDTO> {
    const response = await this.getFeaturedCategoryBySlugRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async patchFeaturedCategoryRaw(
    requestParameters: PatchFeaturedCategoryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters.featuredCategoryId === null || requestParameters.featuredCategoryId === undefined) {
      throw new runtime.RequiredError(
        "featuredCategoryId",
        "Required parameter requestParameters.featuredCategoryId was null or undefined when calling patchFeaturedCategory."
      );
    }

    if (
      requestParameters.featuredCategoriesMvoDTO === null ||
      requestParameters.featuredCategoriesMvoDTO === undefined
    ) {
      throw new runtime.RequiredError(
        "featuredCategoriesMvoDTO",
        "Required parameter requestParameters.featuredCategoriesMvoDTO was null or undefined when calling patchFeaturedCategory."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/featuredCategories/{featuredCategoryId}`.replace(
          `{${"featuredCategoryId"}}`,
          encodeURIComponent(String(requestParameters.featuredCategoryId))
        ),
        method: "PATCH",
        headers: headerParameters,
        query: queryParameters,
        body: FeaturedCategoriesMvoDTOToJSON(requestParameters.featuredCategoriesMvoDTO)
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async patchFeaturedCategory(
    requestParameters: PatchFeaturedCategoryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.patchFeaturedCategoryRaw(requestParameters, initOverrides);
  }

  /**
   */
  async postFeaturedCategoryRaw(
    requestParameters: PostFeaturedCategoryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OutFeaturedCategoriesDTO>> {
    if (
      requestParameters.createFeaturedCategoriesDTO === null ||
      requestParameters.createFeaturedCategoriesDTO === undefined
    ) {
      throw new runtime.RequiredError(
        "createFeaturedCategoriesDTO",
        "Required parameter requestParameters.createFeaturedCategoriesDTO was null or undefined when calling postFeaturedCategory."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/featuredCategories`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateFeaturedCategoriesDTOToJSON(requestParameters.createFeaturedCategoriesDTO)
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => OutFeaturedCategoriesDTOFromJSON(jsonValue));
  }

  /**
   */
  async postFeaturedCategory(
    requestParameters: PostFeaturedCategoryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OutFeaturedCategoriesDTO> {
    const response = await this.postFeaturedCategoryRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async putFeaturedCategoryRaw(
    requestParameters: PutFeaturedCategoryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OutFeaturedCategoriesDTO>> {
    if (requestParameters.featuredCategoryId === null || requestParameters.featuredCategoryId === undefined) {
      throw new runtime.RequiredError(
        "featuredCategoryId",
        "Required parameter requestParameters.featuredCategoryId was null or undefined when calling putFeaturedCategory."
      );
    }

    if (requestParameters.inFeaturedCategoriesDTO === null || requestParameters.inFeaturedCategoriesDTO === undefined) {
      throw new runtime.RequiredError(
        "inFeaturedCategoriesDTO",
        "Required parameter requestParameters.inFeaturedCategoriesDTO was null or undefined when calling putFeaturedCategory."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/featuredCategories/{featuredCategoryId}`.replace(
          `{${"featuredCategoryId"}}`,
          encodeURIComponent(String(requestParameters.featuredCategoryId))
        ),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: InFeaturedCategoriesDTOToJSON(requestParameters.inFeaturedCategoriesDTO)
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => OutFeaturedCategoriesDTOFromJSON(jsonValue));
  }

  /**
   */
  async putFeaturedCategory(
    requestParameters: PutFeaturedCategoryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OutFeaturedCategoriesDTO> {
    const response = await this.putFeaturedCategoryRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
